/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { combineEpics } from "redux-observable";
import interfaceEpics from "./epics/interfaceEpics";
import storageEpics from "./epics/storageEpics";
import syncEpics from "./epics/syncEpics";
import publishEpics from "./epics/publishEpics";

export * from "./actions";
export * from "./reducers";

export const evalEpics = combineEpics(interfaceEpics, storageEpics, syncEpics, publishEpics);
